import React from "react";
import "./Users.css";

export default function Users() {
  return (
    <div className="register dashboard-padding">
      <div className="col-md-12  register-sec">
        <h4>Register</h4>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>First Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter First Name"
            />
          </div>
          <div className="col-md-4 form-group">
            <label>Last Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Last Name"
            />
          </div>
          <div className="col-md-4 form-group">
            <label>Mobile NUmber</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Mobile Number"
            />
          </div>
          <div className="col-md-4 form-group">
            <label>Email Id</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Email"
            />
          </div>
          <div className="col-md-4 form-group">
            <label>Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter Password"
            />
          </div>
          <div className="col-md-4 form-group">
            <label>Status</label>
            <select className="form-control">
              <option value="1">Active </option>
              <option value="2">Inactive </option>
            </select>
          </div>
        </div>
        <h4 className="pt-5">Role Permissions</h4>
        <div className="table-responsive table-sec">
          <table className="table">
            <thead>
              <th>Permissons</th>
              <th>Read</th>
              <th>Write</th>
              <th>SEO Details</th>
            </thead>
            <tbody>
              <tr>
                <td>Dashboard</td>
                <td>
                  <div className="checkbox-input">
                    <input type="checkbox" checked id="terms" />
                  </div>
                </td>
                <td>
                  <div className="checkbox-input">
                    <input type="checkbox" checked id="terms" />
                  </div>
                </td>
                <td>
                  <div className="checkbox-input">
                    <input type="checkbox" id="terms" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>Dashboard</td>
                <td>
                  <div className="checkbox-input">
                    <input type="checkbox" checked id="terms" />
                  </div>
                </td>
                <td>
                  <div className="checkbox-input">
                    <input type="checkbox" checked id="terms" />
                  </div>
                </td>
                <td>
                  <div className="checkbox-input">
                    <input type="checkbox" id="terms" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>Dashboard</td>
                <td>
                  <div className="checkbox-input">
                    <input type="checkbox" checked id="terms" />
                  </div>
                </td>
                <td>
                  <div className="checkbox-input">
                    <input type="checkbox" checked id="terms" />
                  </div>
                </td>
                <td>
                  <div className="checkbox-input">
                    <input type="checkbox" id="terms" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
